import { SEPARATOR_URL_FILTER_VALUES } from '@/configs/tableConfigs';

export type TUrlSearchParam = {
  param: string;
  value: string;
};
export type TUrlSearchParams = Array<TUrlSearchParam>;

export const getUrl = (): URL => {
  return new URL(document.location.href);
};

export const pushHistory = (newUrl) => {
  history.pushState(null, '', newUrl);
};

export const replaceHistory = (newUrl) => {
  history.replaceState(null, '', newUrl);
};

export const getUrlParam = (param: string): string | null => {
  return getUrl().searchParams.get(param);
};

export const sortUrlParams = (url: URL): void => {
  let currentUrl = url;

  if (!currentUrl) {
    currentUrl = getUrl();
  }

  currentUrl.searchParams.sort();
};

export const setUrlParam = (param: string, value: string): URL => {
  const currentUrl = getUrl();

  if (!value) {
    currentUrl.searchParams.delete(param);
  } else {
    currentUrl.searchParams.set(param, value);
  }

  sortUrlParams(currentUrl);

  return currentUrl;
};

export const appendUrlParam = (param: string, value: string): URL => {
  const currentUrl = getUrl();
  currentUrl.searchParams.append(param, value);
  return currentUrl;
};

export const appendUrlParams = (params: TUrlSearchParams): URL => {
  const currentUrl = getUrl();
  if (!params.length) {
    return currentUrl;
  }

  try {
    for (const item of params) {
      currentUrl.searchParams.append(item.param, item.value);
    }

    sortUrlParams(currentUrl);
  } catch (err) {
    console.error('setUrlParams: ', err);
  }

  return currentUrl;
};

export const deleteUrlParams = (param: string): void => {
  const currentUrl = getUrl();
  currentUrl.searchParams.delete(param);
  sortUrlParams(currentUrl);
  pushHistory(currentUrl);
};

export const getAllUrlParams = (param: string): Array<string> => {
  const currentUrl = getUrl();
  const allParams = currentUrl.searchParams.getAll(param);

  if (Array.isArray(allParams)) {
    return allParams;
  } else {
    return [allParams];
  }
};

export const getUrlSearchParamsString = (
  urlSearchParams: URLSearchParams
): string => {
  if (urlSearchParams.toString()) {
    return '?' + urlSearchParams.toString();
  }

  return '';
};

export const splitUrlParamsValue = (value: string): Array<string> => {
  return value.split(SEPARATOR_URL_FILTER_VALUES);
};

export const joinUrlParamsValue = (value1: string, value2: string): string => {
  return [value1, value2].join(SEPARATOR_URL_FILTER_VALUES);
};
